/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Sale, SaleInterface, SaleConstructorConfigStruct } from "../Sale";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "maximumSaleTimeout",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maximumCooldownDuration",
            type: "uint256",
          },
          {
            internalType: "contract RedeemableERC20Factory",
            name: "redeemableERC20Factory",
            type: "address",
          },
        ],
        internalType: "struct SaleConstructorConfig",
        name: "config_",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_size",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "InvalidCodeAtRange",
    type: "error",
  },
  {
    inputs: [],
    name: "WriteError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumUnits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "desiredUnits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maximumPrice",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct BuyConfig",
        name: "config",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "units",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Receipt",
        name: "receipt",
        type: "tuple",
      },
    ],
    name: "Buy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maximumSaleTimeout",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maximumCooldownDuration",
            type: "uint256",
          },
          {
            internalType: "contract RedeemableERC20Factory",
            name: "redeemableERC20Factory",
            type: "address",
          },
        ],
        indexed: false,
        internalType: "struct SaleConstructorConfig",
        name: "config",
        type: "tuple",
      },
    ],
    name: "Construct",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cooldownDuration",
        type: "uint256",
      },
    ],
    name: "CooldownInitialize",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cooldown",
        type: "uint256",
      },
    ],
    name: "CooldownTriggered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum SaleStatus",
        name: "saleStatus",
        type: "uint8",
      },
    ],
    name: "End",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "bytes[]",
                name: "sources",
                type: "bytes[]",
              },
              {
                internalType: "uint256[]",
                name: "constants",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "stackLength",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "argumentsLength",
                type: "uint256",
              },
            ],
            internalType: "struct StateConfig",
            name: "canStartStateConfig",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "bytes[]",
                name: "sources",
                type: "bytes[]",
              },
              {
                internalType: "uint256[]",
                name: "constants",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "stackLength",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "argumentsLength",
                type: "uint256",
              },
            ],
            internalType: "struct StateConfig",
            name: "canEndStateConfig",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "bytes[]",
                name: "sources",
                type: "bytes[]",
              },
              {
                internalType: "uint256[]",
                name: "constants",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "stackLength",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "argumentsLength",
                type: "uint256",
              },
            ],
            internalType: "struct StateConfig",
            name: "calculatePriceStateConfig",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "contract IERC20",
            name: "reserve",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "saleTimeout",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cooldownDuration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumRaise",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "dustSize",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct SaleConfig",
        name: "config",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "Initialize",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "units",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Receipt",
        name: "receipt",
        type: "tuple",
      },
    ],
    name: "Refund",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pointer",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stackIndex",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "stack",
            type: "uint256[]",
          },
          {
            internalType: "bytes[]",
            name: "sources",
            type: "bytes[]",
          },
          {
            internalType: "uint256[]",
            name: "constants",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "arguments",
            type: "uint256[]",
          },
        ],
        indexed: false,
        internalType: "struct State",
        name: "state",
        type: "tuple",
      },
    ],
    name: "Snapshot",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Start",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Timeout",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumUnits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "desiredUnits",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maximumPrice",
            type: "uint256",
          },
        ],
        internalType: "struct BuyConfig",
        name: "config_",
        type: "tuple",
      },
    ],
    name: "buy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "units_",
        type: "uint256",
      },
    ],
    name: "calculatePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "canEnd",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "canStart",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient_",
        type: "address",
      },
    ],
    name: "claimFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "end",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "bytes[]",
                name: "sources",
                type: "bytes[]",
              },
              {
                internalType: "uint256[]",
                name: "constants",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "stackLength",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "argumentsLength",
                type: "uint256",
              },
            ],
            internalType: "struct StateConfig",
            name: "canStartStateConfig",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "bytes[]",
                name: "sources",
                type: "bytes[]",
              },
              {
                internalType: "uint256[]",
                name: "constants",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "stackLength",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "argumentsLength",
                type: "uint256",
              },
            ],
            internalType: "struct StateConfig",
            name: "canEndStateConfig",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "bytes[]",
                name: "sources",
                type: "bytes[]",
              },
              {
                internalType: "uint256[]",
                name: "constants",
                type: "uint256[]",
              },
              {
                internalType: "uint256",
                name: "stackLength",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "argumentsLength",
                type: "uint256",
              },
            ],
            internalType: "struct StateConfig",
            name: "calculatePriceStateConfig",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "contract IERC20",
            name: "reserve",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "saleTimeout",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cooldownDuration",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minimumRaise",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "dustSize",
            type: "uint256",
          },
        ],
        internalType: "struct SaleConfig",
        name: "config_",
        type: "tuple",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "symbol",
                type: "string",
              },
              {
                internalType: "address",
                name: "distributor",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "initialSupply",
                type: "uint256",
              },
            ],
            internalType: "struct ERC20Config",
            name: "erc20Config",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "tier",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "minimumTier",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "distributionEndForwardingAddress",
            type: "address",
          },
        ],
        internalType: "struct SaleRedeemableERC20Config",
        name: "saleRedeemableERC20Config_",
        type: "tuple",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "feeRecipient",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "units",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
        ],
        internalType: "struct Receipt",
        name: "receipt_",
        type: "tuple",
      },
    ],
    name: "refund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "reserve",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "saleStatus",
    outputs: [
      {
        internalType: "enum SaleStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "start",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "timeout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type SaleConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SaleConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Sale__factory extends ContractFactory {
  constructor(...args: SaleConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    config_: SaleConstructorConfigStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Sale> {
    return super.deploy(config_, overrides || {}) as Promise<Sale>;
  }
  getDeployTransaction(
    config_: SaleConstructorConfigStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(config_, overrides || {});
  }
  attach(address: string): Sale {
    return super.attach(address) as Sale;
  }
  connect(signer: Signer): Sale__factory {
    return super.connect(signer) as Sale__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SaleInterface {
    return new utils.Interface(_abi) as SaleInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Sale {
    return new Contract(address, _abi, signerOrProvider) as Sale;
  }
}
